var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer align-center justify-space-between text-center",class:{ above: _vm.position === 'above' }},[_vm._v("\n    © 2018 Corwin Design - Premium Calendars and Newsletters – Previously\n    MyCorwinCalendar.com - All rights reserved\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }